module.exports = __webpack_public_path__ + "static/media/error.77384032.svg";